import { ReactNode } from 'react';

import { Styles, css } from '@flipster/styled-system/css';
import { Token, token } from '@flipster/styled-system/tokens';

type BgColorTokens = Extract<Token, `colors.background.${string}`>;
type GradientColorTokens = Extract<Token, `gradients.${string}`>;

// type BgColorTokens =
//   | 'colors.background.default.level-0'
//   | 'colors.background.default.level-1'
//   | 'colors.background.default.level-3'
//   | 'colors.background.default.level-4'
//   | 'colors.inverse.white'
//   | 'colors.background.accent.primary'
//   | 'colors.background.accent.primary.hover'
//   | 'colors.background.accent.secondary'
//   | 'colors.background.accent.secondary.hover'
//   | 'colors.background.accent.buy'
//   | 'colors.background.accent.buy.hover'
//   | 'colors.background.accent.sell'
//   | 'colors.background.accent.sell.hover'
//   | 'colors.background.interaction.hover'
//   | 'colors.background.interaction.disabled'
//   | 'colors.background.interaction.dim';
// type GradientColorTokens = 'gradients.programs.vip' | 'gradients.programs.promotion';

interface Props {
  bgColor: BgColorTokens;
  gradientColor: GradientColorTokens;
  css?: Styles;
  children?: ReactNode;
}

export const BorderGradientBox = ({ bgColor, gradientColor, css: cssProps, children }: Props) => {
  return (
    <div
      className={css(
        {
          border: '1px solid transparent',
          backgroundClip: 'padding-box, border-box',
          backgroundOrigin: 'border-box',
        },
        cssProps,
      )}
      style={{ backgroundImage: `linear-gradient(${token(bgColor)}, ${token(bgColor)}), ${token(gradientColor)}` }}
    >
      {children}
    </div>
  );
};
